import _ from 'underscore';

function SettingsVenueReportScheduleCtrl($scope, $state, $window, $q, $stateParams, $timeout, venueService, sdkUtils, scheduledReportConfigService, alertService, tagService, formHelpersService, ERROR_MESSAGES, modalService) { //eslint-disable-line

  if (!$scope.venuePromise) {
    return alertService.fatalError(ERROR_MESSAGES.ERROR_GETTING_ORGANIZATION_VENUE);
  }

  _initScope();

  $q.all([
      $scope.venuePromise
    ])
    .finally(() => {
      $scope.loading = false;
    });

  function _initScope() {

    $scope.loading = true;

    // Add functions to scope
    $scope.create = _create;
    $scope.edit = _edit;
    $scope.remove = _remove;
    $scope.addRecipient = _addRecipient;
    $scope.removeRecipient = _removeRecipient;
    $scope.getDaysString = _getDaysString;

    // Initialize Array
    $scope.reports = [];
    _list();
  }

  function _edit(report) {
    modalService.editScheduledReport({
      report: report,
      venueId: $stateParams.venueId
    }).then(_success);
  }

  function _create() {
    modalService.editScheduledReport({
      venueId: $stateParams.venueId
    }).then(_success);
  }

  function _remove(report) {
    if (!report || !report.id) {
      return _error();
    }

    return modalService.confirmation({
        modalHeader: `Delete Report ${report.name}`,
        modalMessage: 'Are you sure you want to delete this report? All recipients will no longer receive this report.',
        confirmBtnTxt: 'Delete Report',
        confirmingBtnTxt: 'Deleting...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          scheduledReportConfigService.deleteById(report.id)
            .then(_success)
            .catch(_error)
            .finally(() => {
              result.modalInstance.close();
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  function _list() {

    $scope.loading = true;
    scheduledReportConfigService.listByVenueId($stateParams.venueId).then(function (resp) {

      // Convert hour & time into a
      // date object for diplay.
      _.each(resp, function (report) {
        const now = new Date();
        now.setHours(report.reportTimeHour);
        now.setMinutes(report.reportTimeMinute);
        report.time = now.getTime();

        report.type = report.reportType;
      });

      $scope.reports = resp;
      $scope.loading = false;
    }).catch(_error);
  }

  function _getDaysString(days) {
    if (!days || days.length < 1 || days.length > 6) {
      return 'Daily';
    }

    const daysOfWeek = ['Sun', 'Mon', 'Tu', 'Wed', 'Th', 'Fri', 'Sat'];

    const retDays = [];

    _.each(days.sort(), day => {
      retDays.push(daysOfWeek[day]);
    });

    return retDays.join(', ');
  }

  /************ Receipients ************/

  function _addRecipient(report) {
    const message = 'Add a recipient. Please enter an e-mail address:';
    const email = window.prompt(message); //eslint-disable-line

    if (!email) return;

    const options = {
      email: email
    };

    scheduledReportConfigService.addEmailRecipient(report.id, options)
      .then(_success)
      .catch(_error);
  }

  function _removeRecipient(report, email) {
    const options = {
      email: email
    };

    modalService.confirmation({
        modalHeader: `Remove Report Recipient ${email}`,
        modalMessage: 'Are you sure you want to remove this recipient? They will no longer recieve this report.',
        confirmBtnTxt: 'Remove Recipient',
        confirmingBtnTxt: 'Removing...',
        size: 'sm'
      })
      .then(result => {
        if (result && result.confirm) {
          scheduledReportConfigService.removeEmailRecipient(report.id, options)
            .then(_success)
            .catch(_error)
            .finally(() => {
              result.modalInstance.close();
            });
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  /************ Helpers ************/

  function _success() {
    // Reload reports list.
    _list();
  }

  function _error(resp) {
    const msg = sdkUtils.getErrorFromResponse(resp);

    alertService.error(msg);

    $scope.loading = false;
  }
}

SettingsVenueReportScheduleCtrl.$inject = [
  '$scope',
  '$state',
  '$window',
  '$q',
  '$stateParams',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.utils',
  'jsSdk.scheduledReportConfig',
  'alertService',
  'jsSdk.tag',
  'formHelpersService',
  'ERROR_MESSAGES',
  'modalService'
];

export default SettingsVenueReportScheduleCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsVenueReportSchedule/settingsVenueReportScheduleCtrl.js